import { applyMiddleware, compose, createStore } from 'redux'
import { configureTranslations } from '@avp/core'
import middleware from './middleware'
import rootReducer from './reducers/rootReducer'
import applyDevtoolExtension from './applyDevtoolExtension'
import { getPersistedState } from './persistState'
import brandSelector from './selectors/brandSelector'
import isTranslationDebugEnabledSelector from './selectors/isTranslationDebugEnabledSelector'

const enhancer = compose(
    applyMiddleware(...middleware),
    applyDevtoolExtension(),
)

// Get persisted state (partial state with only essential data)
const persistedState = getPersistedState()

// Create store - Redux will merge the persisted state with initial state from reducers
const store = createStore(rootReducer, persistedState, enhancer)

configureTranslations({
    read: () => ({
        context: brandSelector(store.getState()),
        showKeys: isTranslationDebugEnabledSelector(store.getState()),
    }),
    subscribe: store.subscribe,
})

export default store
